<script setup>

function status(item) {
    const maps = {
        draft: '✏️',
        waiting: '🕑',
        approve: '✅',
        incomplete: '❗️',
        paid: '💰'
    }
    return maps[item.status]

}

const props = defineProps({
    accountings: {
        type: Array,
        required: true,
        default: []
    }
})

function format(date) {
    return date ? dayjs(date).format('MM-DD') : '--'
}

</script>


<template>
    <div class="max-h-96 overflow-y-scroll">
        <table class="table-fixed w-full">
            <thead>
            <tr class="w-full">
                <th class="w-1/6">id</th>
                <th class="w-1/3 text-sm">expense date</th>
                <th class="w-1/2">name</th>
                <th class="w-1/6">status</th>
            </tr>
            </thead>
            <tbody class=" overflow-y-auto ">
            <template v-for="(item, index) in accountings" :key="item.id">
                <tr
                    @click="$emit('show', item.id)"
                    class="text-center cursor-pointer" :class="index % 2 ? 'bg-gray-200' : ''"
                >
                    <td>{{ item.id }}</td>
                    <td>{{ format(item.expense_date) }}</td>
                    <td class="truncate">{{ item.name }}</td>
                    <td>
                        <button class="rounded p-1 hover:shadow-lg">
                            {{ status(item) }}
                        </button>
                    </td>
                </tr>
            </template>
            </tbody>
        </table>
        <div class="text-center mt-4 text-gray-400 text-lg" v-if="!accountings.length">-------empty data-------</div>
    </div>

</template>
